export default __webpack_public_path__ + "static/media/nine.ab1f318f.svg";